import api from "./api";

const route = "/vehicles";

const VehiclesService = {
  getVehicles: () => api.get(`${route}/admin/all`),
};
export default VehiclesService;
